import axios from 'axios';

import PermissionManager from '../managers/PermissionManager';
import WebApiService from '../services/WebApiService';

export default class AccountService extends WebApiService {

    constructor() {
        super();


        this.ping = this.ping.bind(this);
        this.login = this.login.bind(this);
        this.loginAddSocial = this.loginAddSocial.bind(this);
        this.loginExternal = this.loginExternal.bind(this);
        this.checkEmailMatch = this.checkEmailMatch.bind(this);
        this.createNewAccount = this.createNewAccount.bind(this);
        this.saveLoginResponse = this.saveLoginResponse.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.getUpdatePicAndUserInfo = this.getUpdatePicAndUserInfo.bind(this);
        this.getFacebookPic = this.getFacebookPic.bind(this);
        this.getFacebookInfo = this.getFacebookInfo.bind(this);
        this.getClientAccountAndLocations = this.getClientAccountAndLocations.bind(this);
        this.requestClientAccountLink = this.requestClientAccountLink.bind(this);

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
        this.getExternal = super.getExternal.bind(this);

        this.permissionManager = new PermissionManager();
    }

    ping(successCallback, errorCallback) {
        this.get('/api/Account/Ping', successCallback, errorCallback);
    }

    pingOnline(successCallback, errorCallback) {
        this.get('/api/Account/PingOnline', successCallback, errorCallback);
    }

    login(username, password, successCallback, errorCallback) {
        var self = this;

        username = encodeURIComponent(username);
        password = encodeURIComponent(password);

        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/Token', "grant_type=password&username=" + username + "&password=" + password + "&client_id=web&auth_mode=zeezor")
            .then(function (res) {
                self.saveLoginResponse(res.data, "ZeeZor", null, successCallback, errorCallback);
            }, function (err) {

                if (errorCallback != undefined && err.response != undefined && err.response.data != undefined && err.response.data.error == 'invalid_grant') {
                    errorCallback();
                } else {
                    if (err.response === undefined) {
                        errorCallback("Could not connect to server");
                    } else {

                        errorCallback();
                    }
                }
            });
    }

    //userRequest object
    saveUserProfile(userProfile, successCallback, errorCallback) {
        this.post('/api/account/UpdateUser', userProfile, successCallback, errorCallback);
    }

    saveFeedback(feedback, successCallback, errorCallback) {
        this.post('/api/account/feedback', feedback, successCallback, errorCallback);
    }


    loginAddSocial(username, password, type, id, picUrl, successCallback, errorCallback) {
        var self = this;

        username = encodeURIComponent(username);
        password = encodeURIComponent(password);

        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/Token', "grant_type=password&username=" + username + "&password=" + password + "&client_id=web&auth_mode=zeezorsocial&type=" + type + "&ext_id=" + id)
            .then(function (res) {

                self.saveLoginResponse(res.data, type, picUrl, successCallback, errorCallback);
            }, function (err) {
                if (errorCallback != undefined && err.response != undefined && err.response.data != undefined && err.response.data.error == 'invalid_grant') {
                    errorCallback();
                } else {

                    errorCallback();
                }
            });
    }

    loginExternal(externalType, externalId, picUrl, successCallback, errorCallback) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(self.host + '/Token', "grant_type=password&username=" + "external" + "&password=" + "nopass" + "&client_id=web&auth_mode=" + externalType + "&external_id=" + externalId)
            .then(function (res) {

                self.saveLoginResponse(res.data, externalType, picUrl, () => {
                    successCallback(externalType, externalId);
                }, errorCallback);
            }, function (err) {
                if (errorCallback != undefined && err.response != undefined && err.response.data != undefined && err.response.data.error == 'invalid_grant') {
                    errorCallback(externalType, externalId);
                } else {
                    errorCallback(externalType, externalId);
                }
            });
    }

    loginInstagram(token, successCallback, errorCallback) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .get("https://api.instagram.com/v1/users/self/?" + token)
            .then(function (res) {
                if (successCallback != null && successCallback != undefined) {
                    successCallback(res.data.data);
                }
            }, function (err) {
                if (errorCallback != null && errorCallback != undefined) {
                    errorCallback(err);
                }
            });
    }

    checkEmailMatch(email, successCallback, errorCallback) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/api/Account/CheckEmail', { externalEmail: email })
            .then(function (res) {
                if (successCallback != null && successCallback != undefined) {
                    successCallback(res.data);
                }
            }, function (err) {
                if (errorCallback != null && errorCallback != undefined) {
                    errorCallback(err);
                }
                else {

                }
            })
    }

    linkAccount(email, type, id, successCallback, errorCallback) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/api/Account/LinkAccount', { email: email, type: type, id: id })
            .then(function (res) {
                successCallback(res.data);
            }, function (err) {
                if (errorCallback != undefined) {
                    errorCallback();
                } else {

                }
            })
    }

    createNewAccount(data, successCallback, errorCallback) {
        var self = this;


        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/api/Account/NewUser', data, { headers: { 'Content-Type': 'application/json' } })
            .then(function (res) {
                if (res.data === 'pass' || /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(res.data)) {
                    self.login(data.username, data.password, successCallback, errorCallback);
                } else {
                    successCallback(res.data);
                }
            }, function (err) {
                if (errorCallback) {
                    errorCallback(err);
                }

            })
    }

    submitForgotPassword(email, successCallback, errorCallback) {
        var self = this;

        delete axios.defaults.headers.Authorization;
        axios
            .post(this.host + '/api/Account/ForgotPassword', { email: email })
            .then((res) => {
                if (successCallback)
                    successCallback(res.data);
            }, (err) => {
                if (errorCallback)
                    errorCallback(err);
            });
    }

    saveLoginResponse(data, loginType, picUrl, callback, errorCallback) {
        var self = this;

        this.dbm.saveAuthInfo(data).then(() => {

            if (loginType.toUpperCase() == "ZEEZOR") {
                self.getUserInfo(data.userId.toUpperCase(), function (res) {
                    self.dbm.saveAccountInfo(res).then(() => {
                        if (callback)
                            callback();
                    }, (err) => {

                        if (errorCallback) {
                            errorCallback();
                        }
                    });
                }, function (err) {

                    if (errorCallback) {
                        errorCallback();
                    }
                });
            }
            else {
                self.getUpdatePicAndUserInfo(data.userId.toUpperCase(), loginType, picUrl, function (res) {
                    self.dbm.saveAccountInfo(res).then(() => {
                        if (callback)
                            callback();
                    }, (err) => {

                        if (errorCallback) {
                            errorCallback();
                        }
                    });
                }, function (err) {

                    if (errorCallback) {
                        errorCallback();
                    }
                });
            }
        }, (err) => {

            if (errorCallback) {
                errorCallback();
            }
        });

    }

    getUserInfo(userId, successCallback, errorCallback) {
        let self = this;
        this.get('/api/Account/UserInfo/' + userId.toUpperCase(),
            (result) => {
                self.permissionManager.setUserType(result.userType);
                successCallback(result)
            },
            errorCallback);
    }

    getUpdatePicAndUserInfo(userId, loginType, picUrl, successCallback, errorCallback) {
        this.post('/api/Account/UpdatePicAndGetUserInfo', {
            loginType: loginType,
            picUrl: picUrl,
            userId: userId
        }, successCallback, errorCallback);
    }

    getFacebookPic(fbId, successCallback, errorCallback) {
        this.getExternal("https://graph.facebook.com/v2.12/" + fbId + "/picture", successCallback, errorCallback);
    }

    getFacebookInfo(accessToken, successCallback, errorCallback) {
        this.getExternal("https://graph.facebook.com/v2.12/me?access_token=" + accessToken + "&fields=email%2Cfirst_name%2Clast_name%2Cpicture.type(large)&method=get&pretty=0&sdk=joey&suppress_http_code=1", successCallback, errorCallback);
    }


    getClientAccountAndLocations(successCallback, errorCallback) {
        this.get('/api/Account/ClientAccountAndLocations', successCallback, errorCallback);
    }

    requestClientAccountLink(linkClientAccountRequest, successCallback, errorCallback) {
        this.post('/api/Account/RequestClientAccountLink', linkClientAccountRequest, successCallback, errorCallback);
    }

    getGroups(clientAccountId, successCallback, errorCallback) {
        this.get('/api/Account/GroupsByClientAccount/' + clientAccountId, successCallback, errorCallback);
    }
}